export default {
      id: "chevrons-right-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "app/svg/sprite.svg#chevrons-right",
      toString: function () {
        return this.url;
      }
    }